import React from 'react';
import { Flex } from 'reflexbox';
import Media from 'react-media';
import { QuestionCard, QUESTION_CARD_DEFAULT_WIDTH } from 'boss-ui';
import EditableQuestionBigCard from './EditableQuestionBigCard';
import { useScenarioContext } from '../../libs/context-lib';

const getGridConfiguration = (matches) => {
  if (matches.s) {
    return '1fr';
  }
  if (matches.xl) {
    return '1fr 1fr 1fr';
  }
  return `${QUESTION_CARD_DEFAULT_WIDTH} ${QUESTION_CARD_DEFAULT_WIDTH}`;
};

export default function QuestionsGrid({
  onQuestionCardClick = () => {},
  onQuestionCardClosed = () => {},
  onQuestionRemoved = () => {},
  focusedQuestionId,
  removingQuestionId,
  isImportationView = false,
  eventId,
}) {
  const { state } = useScenarioContext();
  return (
    <Media
      queries={{
        s: '(max-width: 1000px)',
        m: '(max-width: 1290px)',
        l: '(max-width: 1540px)',
        xl: '(min-width: 1880px)',
      }}
    >
      {(matches) => (
        <Flex
          style={{
            display: 'grid',
            gridTemplateColumns: getGridConfiguration(matches),
            gridGap: '22px',
            gridAutoFlow: 'dense',
          }}
          className="ScenarioQuestions-Questions"
        >
          {state.questionsList.map((q, idx) => {
            const isSelected = focusedQuestionId === q.question.question_id;
            const isQuestionBeingRemoving = removingQuestionId === q.question.question_id;
            const hasQuestionError = state.error && state.error.questionLine === idx;
            return (
              <React.Fragment key={q.question.question_id}>
                <QuestionCard
                  isEditionView
                  selectedCard={isSelected}
                  question={q.question}
                  answer={q.answer}
                  points={q.total}
                  onSelectCard={() => onQuestionCardClick(q.question)}
                  onRemoveQuestion={() => onQuestionRemoved(q.question.question_id)}
                  removingQuestion={isQuestionBeingRemoving}
                  error={hasQuestionError && state.error}
                />
                {isSelected && (
                  <EditableQuestionBigCard
                    media={matches}
                    onClose={onQuestionCardClosed}
                    isImportationView={isImportationView}
                    eventId={eventId}
                  />
                )}
              </React.Fragment>
            );
          })}
        </Flex>
      )}
    </Media>
  );
}
